<template>
  <div class="p-grid">
    <div class="p-col-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <!--{{listData}}-->
        <BaseDatatable :key="componentKey" @selectedService="selectedService" :tableData="listData" :model="dataModel"
          :options="options" :filterDefault="filters" :getFilterOptions="getFilterOptions" :actions="getRowActions()"
          v-on:action-click="onActionClicked" @filterData="changeFilterData"></BaseDatatable>
        <template id="frm_action">
          <Dialog :header="`Delete payment # ${codePayment}`" :visible.sync="showDeleteDialog"
            :contentStyle="{ overflow: 'visible' }" :modal="true">
            <p>Are you sure you want to delete this payment? You cannot undo this action.</p>
            <div class="p-field">
              <label for="delete_reason" class="p-d-block txt-required">Why delete payment? </label><br>
              <textarea id="delete_reason" rows="3" v-model="deleteReason" :maxlength="500"
                placeholder="Write something here (max: 500 characters)..."
                class="p-inputtext-lg p-d-block custom-textarea"></textarea>
            </div>
            <template #footer>
              <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-secondary" />
              <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
                class="p-button-danger  btn-confirm-delete-dialog" />
            </template>
          </Dialog>
        </template>
        <Dialog :header="`Confirm this payment #${codePayment}`" :visible.sync="showConfirmDialog"
          :contentStyle="{ overflow: 'visible' }" :modal="true">
          By confirming this payment, you acknowledge that it is now fully paid. <br><br>
          Please note: Once confirmed, the payment details will become uneditable <br>
          within the system.
          <template #footer>

            <Button label="Cancel" @click="showConfirmDialog = false" icon="pi pi-times" class="p-button-warning" />
            <Button label="Confirm" @click="confirmData()" icon="pi pi-check"
              class="p-button-danger  btn-confirm-delete-dialog" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import ApiRepository from "@/core/ApiRepository";
export default {
  components: {
    BaseDatatable
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Need to pay'},
      ],
       dataConfirmNeddToPay: null,

      filters: {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      countRelationship: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      showConfirmDialog: false,
      whereKeyList: {
        where_key: {
          deleted: { _eq: false }
        },
      },
      page_transaction: null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      colorArr: [
        '#BBB2F9',
        '#F8D8AB',
        '#BBEFA8',
        '#A7C3FA',
        '#F3B1AF'
      ],
      filterData: {},
      selected: null,
      deleteReason: '',
      totalAmount: 0,
      codePayment: '',
    }
  },
  mounted() {
    this.initParams();

  }
  ,
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if (this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_NEED_TO_PAY);
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0) {
      this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
    }
    // console.log("arr_role:" ,arr_role)
    this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false : true;
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false : true;
    this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false : true;
    // var arr_role_clubs = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CLUBS);
    // // console.log('role_clubrole_club',arr_role_clubs)
    // if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.view_club = false;
    // }else{
    //   this.view_club = true;
    // }
    // console.log('this.view',this.view_club)
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    changeFilterData(data) {
      this.filterData = {};
      for (const [key, value] of Object.entries(data)) {
        this.filterData[key] = value.value;
      }
    },
    selectedService(data) {
      this.selected = data;
      if (this.filterData?.ids) {
        delete this.filterData.ids;
      }
      if (this.selected && this.selected.length > 0) {
        let arr = [];
        this.selected.map(m => {
          arr.push(m.id);
        })
        if (arr.length > 0) {
          this.filterData.ids = arr;
        }
      }
    },
    async exportCSV() {
      this.$commonFuction.is_loading(true);
      const headers = {
        "Authorization": "Bearer " + (await this.$AuthenticationApp.getToken()),
      };
      var dataUpd = { filter: this.filterData }
      await ApiRepository.post('_api/common/export_excel_service_order', dataUpd, { headers }).then((res) => {
        console.log(res);
        if (res?.data?.data?.excelFile) {
          window.open(res?.data?.data?.excelFile);
        }
        this.$commonFuction.is_loading(false);
      }).catch(async error => {
        console.log('error', error);
        this.$toast.add({
          severity: 'error',
          summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000
        });
        this.$commonFuction.is_loading(false);
      })
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      await this.callbackOptions();
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      for (let index = 0; index < fields.length; index++) {
        var attributes = [];
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          // console.log("SDFGHJK",element)
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_ = {}
          var result;
          if (element['name'] == 'group_channel_name') {
            where_ = {
              active: { _eq: true },
              deleted: { _eq: false },
            }
          }
          if (element['name'] == 'channel_name') {
            where_ = {
              active: { _eq: true },
              deleted: { _eq: false },
            }
          }
          if (element['name'] == "service_name") {
            // console.log("element",element)
            let { data } = await this.$apollo.query({
              query: DataServices.getList("service", { "fields": "id name" }),
              variables: {
                where_key: {
                  deleted: { _eq: false },
                  parent_id: { _is_null: true }
                },
                orderBy: [{ ordinal: 'desc' }, { created_at: 'desc' }]
              }
            })
            if (data) {
              result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({ value: ele[attributes[0]], label: ele[attributes[1]] })
                }
              }
            }
          } else {
            if (element['name'] == 'group_channel_name') {
              where_ = {
                "channel": {
                  "deleted": {
                    "_eq": false
                  }
                },
                "deleted": {
                  "_eq": false
                }
              }
            } else {
              if (element.where_option) {
                where_ = element.where_option
              }
            }
            let { data } = await this.$apollo.query({
              query: DataServices.getList(element.models.tableName, { "fields": attributes.join(',') }),
              variables: { where_key: where_ }
            })
            if (data) {
              result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({ value: ele[attributes[0]], label: ele[attributes[1]] })
                }
              }
            }
          }
          // console.log("optionsData",optionsData)
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options) result = field.options;
        else if (field.models && this.options[name]) result = this.options[name];
      } else {
        if (field.options) { result = field.options; }
        else if (field.models && this.options[name]) result = this.options[name];
        else {
          result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
        }
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (this.role.add) {
        actions.header = { name: 'add', icon: 'plus', path: `list-payment_history/add` };
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        console.log('111111111111111111111111111111111111111', rowData.status);

        var buttons = {}
        if (rowData.status == 'Need to pay') {
          buttons.view = { name: 'confirm', icon: 'check-circle', key: 'id', path: `list-payment_history/view/` };
          if (that.role.delete) {
            buttons.delete = { name: 'delete', icon: 'trash', key: 'id' }
          }
        } if (rowData.status === 'Need to pay' && rowData.type === 3) {
          if (that.role.edit) {
            buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/` };
          }
        }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}


        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      console.log('payloadpayloadpayloadpayloadpayloadpayloadpayload', payload);

      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (data.data?.status == 'ST002') {
            this.$router.push({ path: `/admin/list-visit/edit/${data.data?.order?.visit?.id}` })
            return;
          }
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key], query: { page_transaction: pageTransaction.toString() } })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', data.data[action.key]);
          this.codePayment = data.data.code;
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'confirm':
        this.codePayment = data.data.code;
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.dataConfirmNeddToPay = data.data;
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showConfirmDialog = true
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "delete_reason", value: this.deleteReason },
      ];
      let isFormInvalid = false;

      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        console.log('tagNametagNametagNametagNametagName', this.deleteReason);
        
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          } else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let inpObj = document.getElementById("delete_reason");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async deleteData() {
      // this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        // this.$commonFuction.is_loading(false);
        return; 
      }
      this.showDeleteDialog = false;
      let variables = {
        'data_update': {
          status: 'Fail',
          deletion_reason: this.deleteReason,
          payment_method: '-'
        },
        'where_key': {
          'id': { '_eq': this.deleteId }
        }
      };

      await this.$apollo.mutate({
        mutation: DataServices.updateData('payment_history'),
        variables: variables
      }).then(async (res) => {
        console.log("res", res);
        this.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Delete data successfully',
          life: 3000
        });
        this.componentKey++;
      }).catch((error) => {
        console.error("Error:", error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'There was a problem deleting the payment. Please try again.',
          life: 3000
        });
      });
    },

    async confirmData() {
      console.log('vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv',this.deleteId);
      
      this.showConfirmDialog = false;
 
      if (this.deleteId) {
        let variables = {
        'data_update': { status: 'Success', payment_method: 'Other', late_fee : 0, total_late : 0 },
        'where_key': {
          'id': { '_eq': this.deleteId }
        }
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('payment_history'),
        variables: variables
      }).then(async (res) => {
        var type =this.dataConfirmNeddToPay?.type;
          if(type ==this.$constants.TYPE_PAYMENT_HISTORY.FINAL_PAYMENT){
            //update final payment
            await this.$CoreService.updateFinalPaymentBill(this.dataConfirmNeddToPay?.obj_id)
          }
        console.log("res", res);
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'comfirm data successfully', life: 3000 })
        this.componentKey++;
      });
      }

    }
  },

}
</script>
<style lang="css">
.p-calendar .p-datepicker {
  width: 280px;
  padding: 0px;
  padding-top: 5px;
}

.p-calendar .p-datepicker td,
.p-calendar .p-datepicker td a {
  padding: 0px !important;
}

.total_need_to_pay {
  font-weight: 400;
}

.p-calendar .p-datepicker td span {
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;
}

.p-datepicker .p-datepicker-header {
  padding: 5px !important;
}

/* .p-button-warning .p-button-label {
  color: #1D76BC;
} */

.p-button-warning .pi-times {
  color: #1D76BC;
}

.color-box {
  height: 30px;
  width: 30px;
  margin-right: 10px;
}

.total-section {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  padding: 10px 20px;
  border-radius: 5px;
}

.icon-section {
  background-color: #CFA71A;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.total-icon {
  color: white;
  font-size: 1.5em;
}

.text-section {
  font-weight: bold;
  color: #333;
}

.total-amount {
  margin-left: 5px;
  color: #333;
  font-weight: bold;
}

.export-button {
  width: 120px;
  height: 40px;
  text-align: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  background-color: #FFDF01;
  color: black !important;
  border: none;
  font-weight: 500;
}

.export-button:hover {
  background-color: #fbc02d !important;
  /* Màu mới khi hover */
  color: rgb(32, 3, 3) !important;
  /* Đổi màu chữ khi hover */
}

.custom-textarea {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #c5c5c5;
  padding: 12px;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  box-sizing: border-box;
  /* Đảm bảo padding không làm thay đổi kích thước tổng thể */
  background-color: #fff;
}

.custom-textarea::placeholder {
  color: #999;
  /* Màu placeholder nhẹ hơn */
  font-style: italic;
}

.p-field label {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}
</style>